import store from "../../../store";
import pwa_export from "./pwa_export.vue";

window.pwa_export =  new Vue({
    store,
    el: 'div#pwa_export',

    name : "pwa_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        pwa_export,
    }
});
